exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// /Users/luca/dev/lucagarbin/mascioni.it/~/core-js/modules/_wks-ext.js
// module id = 118
// module chunks = 0